"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSnacks = void 0;
const getSnacks = state => state.snacks.entities;
exports.getSnacks = getSnacks;